<template>
  <div id="dashboard" class="fill-height align-start">
    <i-overlay v-if="alertsDialog" text="Loading dashboard..." />

    <flewid-dialog
      scrollable
      persistent
      content-class="i-dialog"
      v-if="alertsDialog"
      v-model="alertsDialog"
      width="500"
    >
      <i-alerts-dialog :data="alertData" @close="closeAlertsDialog" />
    </flewid-dialog>

    <div class="g-container">
      <v-row class="mb-4 mb-md-10">
        <v-col cols="12">
          <i-trading-steps />
        </v-col>

        <v-col cols="12" lg="6">
          <v-card class="p-main-card pa-4 px-md-6">
            <div class="p-profile-div-wrapper">
              <div class="p-profile-icon">
                <v-img src="@/assets/profile_icon.svg" contain />
              </div>
              <div class="p-profile-info">
                <h3 class="g-heading-xs p-user-name">
                  Hi {{ truncatedContactName }}
                </h3>
                <router-link class="i-text-link" :to="{ name: 'account' }">
                  Manage My Account
                </router-link>
              </div>
            </div>

            <v-divider class="mt-4 mb-3" horizontal></v-divider>

            <v-row>
              <v-col cols="12" sm="6" lg="7">
                <h4 class="pt-3 pb-2 g-heading-xs">
                  Welcome to {{ isILR ? 'ILR Marketplace' : 'FLEWiD' }}
                </h4>
                <div class="pr-md-4">
                  <ul>
                    <li>Replicate current trading arrangements</li>
                    <li>
                      Customise new trading offers for
                      {{ isILR ? 'ILR Marketplace' : 'Independent Retailers' }}
                    </li>
                    <li>
                      Pricing & Promotions mirrored in the
                      {{ isILR ? 'Customer' : 'Retailer' }} Marketplace
                    </li>
                    <li>Expand distribution & geographical reach</li>
                    <li>Increase revenue opportunities</li>
                    <li>Reduce the cost of doing business</li>
                    <li>Guaranteed payment</li>
                    <li>Optimise field force with Turn In order capacity</li>
                  </ul>
                </div>
              </v-col>
              <v-col cols="12" sm="6" lg="5">
                <v-img
                  v-if="isILR"
                  contain
                  class="p-mobile-image"
                  src="@/assets/ilrmarketplace_mobile.png"
                >
                </v-img>
                <v-img
                  v-else
                  contain
                  class="p-mobile-image"
                  src="@/assets/flewid_tech_mobile.png"
                >
                </v-img>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" lg="6" class="py-0">
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="d-flex"
              style="flex-direction: column"
            >
              <v-card class="p-sub-card pa-4 px-md-6 flex-grow-1">
                <v-row align="center">
                  <v-icon class="p-icon">mdi-hammer-screwdriver</v-icon>
                  <p class="g-text-l g-bold">Range Setup & Maintenance</p>
                </v-row>
                <v-divider class="mt-2 mb-3" horizontal></v-divider>
                <div class="p-inner-card">
                  <div>
                    Set up & maintain:<br />
                    <ul>
                      <li>Product details</li>
                      <li>Price & Ranging</li>
                      <li>Images</li>
                      <li>Stock availability</li>
                      <li>Family Groups</li>
                    </ul>
                  </div>
                </div>
                <router-link class="i-text-link" :to="{ name: 'products' }">
                  Range & Pricing Details
                </router-link>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="d-flex"
              style="flex-direction: column"
            >
              <v-card class="p-sub-card pa-4 px-md-6 flex-grow-1">
                <v-row align="center">
                  <v-icon class="p-icon">mdi-truck-outline</v-icon>
                  <p class="g-text-l g-bold">Supplier Trading Rules</p>
                </v-row>
                <v-divider class="mt-2 mb-3" horizontal></v-divider>
                <div class="p-inner-card">
                  <div>
                    Set up & maintain:<br />
                    <ul>
                      <li>Minimum Order value</li>
                      <li>Free Freight value</li>
                      <li>
                        Additional Freight Cost per Carton
                        <ul>
                          <li>National, State or Zone basis</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <router-link
                  class="i-text-link"
                  :to="{ name: 'trading-rules' }"
                >
                  Manage Trading Rules
                </router-link>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="d-flex"
              style="flex-direction: column"
            >
              <v-card class="p-sub-card pa-4 px-md-6 flex-grow-1">
                <v-row align="center">
                  <v-icon class="p-icon">mdi-hammer-screwdriver</v-icon>
                  <p class="g-text-l g-bold">
                    {{ isILR ? 'Customer' : 'Retailer' }} Credit Requests
                  </p>
                </v-row>
                <v-divider class="mt-2 mb-3" horizontal></v-divider>
                <div class="p-inner-card-bottom">
                  <div>
                    Order Queries<br />
                    <ul>
                      <li>Approve or Reject</li>
                    </ul>
                  </div>
                  <div v-if="featureCreditReturnsEnabled">
                    Credit Returns (by request)<br />
                    <ul>
                      <li>Approve or Reject</li>
                    </ul>
                  </div>
                </div>
                <div>
                  <router-link
                    class="i-text-link"
                    :to="{ name: 'order-queries' }"
                  >
                    Order Queries
                  </router-link>
                </div>
                <div v-if="featureCreditReturnsEnabled">
                  <router-link
                    class="i-text-link"
                    :to="{ name: 'credit-returns' }"
                  >
                    Credit Returns
                  </router-link>
                </div>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
              class="d-flex"
              style="flex-direction: column"
            >
              <v-card class="p-sub-card pa-4 px-md-6 flex-grow-1">
                <v-row align="center">
                  <v-icon class="p-icon">mdi-tag-outline</v-icon>
                  <p class="g-text-l g-bold">Promotions</p>
                </v-row>
                <v-divider class="mt-2 mb-3" horizontal></v-divider>
                <div class="p-inner-card-bottom">
                  <div>
                    Setup by Banner, MSO or {{ isILR ? 'Customer' : 'Retailer'
                    }}<br />
                    <ul>
                      <li>
                        <router-link
                          class="i-text-link"
                          :to="{ name: 'specials' }"
                          >Specials</router-link
                        >
                      </li>
                      <li>
                        <router-link
                          class="i-text-link"
                          :to="{ name: 'price-drops' }"
                          >Price Drops</router-link
                        >
                      </li>
                      <li>
                        <router-link
                          class="i-text-link"
                          :to="{ name: 'volume-buys' }"
                          >Volume Buys<template
                            v-if="featureSubscriptionEnabled"
                          >
                            (*Premium only)</template
                          ></router-link
                        >
                      </li>
                      <li v-if="featureCouponsEnabled">
                        <router-link
                          class="i-text-link"
                          :to="{ name: 'coupons' }"
                          >Coupons<template v-if="featureSubscriptionEnabled">
                            (*Premium only)</template
                          ></router-link
                        >
                      </li>
                    </ul>
                  </div>
                </div>
                <router-link
                  class="i-text-link"
                  :to="{ name: 'data-maintenance' }"
                >
                  Data Setup & Maintenance
                </router-link>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex" style="flex-direction: column">
              <v-card class="p-sub-card pa-4 px-md-6 flex-grow-1">
                <p>
                  Advertise in the
                  {{ isILR ? 'Customer' : 'Retailer' }} marketplace,
                  communicating directly to
                  {{ isILR ? 'Customers' : 'Retailers' }} at the point of
                  ordering. Contact
                  <a
                    class="i-a-link"
                    :href="'mailto:' + supportEmail"
                    target="_blank"
                    >{{ supportEmail }}</a
                  >
                  for details.
                </p>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mb-4 mb-md-10" justify="center">
        <v-col cols="12" class="pb-4">
          <h2 class="g-heading-l text-center">Expose your brands & range</h2>
        </v-col>
        <v-col cols="12" md="6" lg="4" style="flex-direction: column">
          <v-card class="p-expose-card pa-4 px-md-6 flex-grow-1">
            <v-row align="center">
              <v-icon class="p-icon">mdi-youtube-subscription</v-icon>
              <p class="g-text-l g-bold">
                Help {{ isILR ? 'Customers' : 'Retailers' }} find your range
                through
              </p>
            </v-row>
            <v-divider class="mt-2 mb-3" horizontal></v-divider>
            <div class="p-inner-card-brands">
              <ul>
                <li>Unlimited product listings - endless aisle</li>
                <li>Search optimisation</li>
                <li>Advanced keyword search</li>
                <li>New products</li>
                <li>Best sellers</li>
                <li>{{ promotionsMarketplaceText }}</li>
              </ul>
            </div>
            <br />
            <router-link
              v-if="featureSubscriptionEnabled"
              class="i-text-link"
              :to="{ name: 'subscription' }"
            >
              Manage Subscriptions
            </router-link>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" lg="4" style="flex-direction: column">
          <v-card class="p-expose-card pa-4 px-md-6 flex-grow-1">
            <v-row align="center">
              <v-icon class="p-icon">mdi-image-multiple-outline</v-icon>
              <p class="g-text-l g-bold">Optimise & Promote Branding</p>
            </v-row>
            <v-divider class="mt-2 mb-3" horizontal></v-divider>
            <div class="p-inner-card-brands">
              <ul>
                <li>Improve customer awareness</li>
                <li>Supplier & Brand logos placement</li>
                <li>Highlight key brands</li>
                <li>Site advertising</li>
                <li>Dedicated supplier range page</li>
                <li>Data & Reports</li>
              </ul>
            </div>
            <br />
            <router-link class="i-text-link" :to="{ name: 'brand-logos' }">
              Add Logos & Brand images<template
                v-if="featureSubscriptionEnabled"
              >
                (*Premium only)</template
              >
            </router-link>
          </v-card>
        </v-col>
      </v-row>

      <i-setup-and-trade-steps v-if="$vuetifyDisplay.mdAndUp && !isILR" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import iAlertsDialog from '@/components/AlertsDialog'
import iOverlay from '@/components/Overlay'
import iSetupAndTradeSteps from '../components/SetupAndTradeSteps'
import iTradingSteps from '@/components/TradingSteps'
import FlewidDialog from '@/components/FlewidDialog'

export default {
  components: {
    iAlertsDialog,
    iOverlay,
    iSetupAndTradeSteps,
    iTradingSteps,
    FlewidDialog
  },

  data: () => ({
    alertsDialog: null
  }),

  computed: {
    ...mapGetters('tenant', [
      'featureCreditReturnsEnabled',
      'featureSubscriptionEnabled',
      'featureCouponsEnabled',
      'supportEmail',
      'isILR'
    ]),

    promotionsMarketplaceText() {
      return this.featureCouponsEnabled
        ? 'Specials, Volume Buys & Coupons'
        : 'Specials, Volume Buys'
    },
    ...mapGetters('notifications', ['displayAlerts', 'alertData']),
    ...mapState('auth', ['contact']),

    truncatedContactName() {
      const MAX_LENGTH = 30
      const firstName = this.contact.firstName
      return firstName?.length > MAX_LENGTH
        ? firstName.substr(0, MAX_LENGTH) + '...'
        : firstName
    }
  },

  methods: {
    ...mapActions('notifications', ['setAlertsAsSeen']),

    closeAlertsDialog() {
      this.alertsDialog = false
    }
  },

  mounted() {
    this.alertsDialog = this.displayAlerts
  },

  watch: {
    displayAlerts() {
      this.alertsDialog = this.displayAlerts
    }
  }
}
</script>

<style lang="scss" scoped>
#dashboard {
  .p-icon {
    width: 32px;
    height: 32px;
    margin-left: 8px;
    margin-right: 8px;
    color: $secondary-color;
  }
  .p-mobile-image {
    max-width: 100px;
    margin: auto;
  }
  .p-profile-div-wrapper {
    .p-profile-icon {
      margin: auto;
      margin-bottom: 8px;
      min-width: 50px;
      width: 100%;
      max-width: 75px;
    }
    .p-profile-info {
      text-align: center;
    }
  }
  .p-user-name {
    word-break: break-word;
  }
}

@media only screen and (min-width: 600px) {
  #dashboard {
    .p-mobile-image {
      max-width: 130px;
    }
    .p-profile-div-wrapper {
      display: flex;
      align-items: center;
      .p-profile-icon {
        margin: initial;
        max-width: 100px;
      }
      .p-profile-info {
        text-align: left;
        margin-left: 5%;
      }
    }
  }
}

@media only screen and (min-width: 960px) {
  #dashboard {
    .p-mobile-image {
      max-width: 140px;
    }
    .p-main-card,
    .p-sub-card,
    .p-expose-card {
      height: 100%;
    }
    .p-inner-card {
      height: 185px;
    }
    .p-inner-card-bottom {
      height: 145px;
    }
  }
}

@media only screen and (min-width: 1264px) {
  #dashboard {
    .p-mobile-image {
      max-width: 165px;
    }
    .p-inner-card {
      height: 185px;
    }
    .p-inner-card-bottom {
      height: 170px;
    }
    .p-inner-card-brands {
      height: 160px;
    }
  }
}

@media only screen and (min-width: 1415px) {
  #dashboard {
    .p-mobile-image {
      max-width: 200px;
    }
    .p-inner-card-bottom {
      height: 135px;
    }
    .p-inner-card-brands {
      height: 150px;
    }
  }
}

@media only screen and (min-width: 1515px) {
  #dashboard {
    .p-inner-card {
      height: 190px;
    }
  }
}
</style>
